import * as React from "react";
import JwtService from "app/services/jwtService";
import CrmJwtService from 'app/services/crm/CrmJwtService';
import EcommerceJwtService from 'app/main/ecommerce/services/ecommerceJwtService';
import CONFIG from "app/config";
import { isDuplicatedWindow } from "./AppDuplicateTab";

const AppAutoLogout = ({ children }) => {

    React.useEffect(() => {

        console.log("isDuplicatedWindow", isDuplicatedWindow((15 * 1000), (10 * 1000), "cmi-oss-system-intermed-llc"));

        const handleTabClose = (ev) => {
            if (CONFIG.env != 'dev') {
                // ev.preventDefault();

                if (isDuplicatedWindow((15 * 1000), (10 * 1000), "cmi-oss-system-intermed-llc")) {
                    JwtService.setJwtLoginReload(false);
                    CrmJwtService.setJwtLoginReload(false); 
                    EcommerceJwtService.setJwtLoginReload(false);
                }

                if (JwtService.getJwtLoginReload() == 'true') {
                    JwtService.logout();
                }

                if (CrmJwtService.getJwtLoginReload() == 'true') {
                    CrmJwtService.logout();
                    localStorage.setItem('tenantReferenceNum', false);
                    localStorage.setItem('tenant', false);
                }

                if (EcommerceJwtService.getJwtLoginReload() == 'true') {
                    EcommerceJwtService.logout();
                }

                if (['/crmlogin', 'crm'].includes(window.location.pathname)) {
                    CrmJwtService.setJwtLoginReload(false);
                } else if (['/login'].includes(window.location.pathname)) {
                    JwtService.setJwtLoginReload(false);
                } else if (window.location.pathname.includes("/e-commerce/")) {
                    EcommerceJwtService.setJwtLoginReload(false);
                } else {
                    JwtService.setJwtLoginReload(true);
                    CrmJwtService.setJwtLoginReload(true);
                    EcommerceJwtService.setJwtLoginReload(true);
                }

                return (ev.returnValue = '');                
            }
        };

        window.addEventListener('beforeunload', handleTabClose);

        return () => {
            window.removeEventListener('beforeunload', handleTabClose);
        };

    }, []);

    return children;
};

export default AppAutoLogout;
